export default __webpack_public_path__ + "static/media/down-btn.14ea731c.png";